<template lang="pug">
v-col(class="tw-bg-white tw-rounded-md px-4 fill-height d-flex flex-column min-h-0 flex-grow-1")
  v-row(no-gutters align="center" justify-space-between class=" flex-shrink-1 flex-grow-0")
    v-col
      span(class=" tw-text-lg tw-font-bold") {{ $t('Common.opportunities') }}
    v-col(class="text-right")
      v-btn(
        outlined
        text
        :ripple="false"
        color="blue-grey lighten-2"
        :to="{ name: 'opportunities' }"
      )
        span(class="tw-font-medium") {{ $t('Common.viewAll') }}
  v-row(no-gutters class=" d-flex flex-column flex-grow-1 tw-max-h-full flex-shrink-0 tw-min-h-0 ")
    v-col(class="flex-grow-1 d-flex overflow-auto flex-column flex-shrink-0 min-h-0  ")
      v-sheet(v-if="opportunities.length > 0 && !loading" elevation="0")
        kubiqa-opportunities-list-item(
          v-for="opportunity in opportunities"
          :key="opportunity.id"
          :opportunity="opportunity"
        )
      div(v-if="!loading && opportunities.length == 0" class=" tw-flex tw-justify-center tw-h-full tw-items-center")
        kubiqa-misc-empty-state(
          :title="$t('Common.emptyStates.opportunitiesTitle')"
          :description="$t('Common.emptyStates.noOpenOpportunities')"
          compact
          icon="mdi-handshake-outline"
        )
      div(v-if="loading")
        v-skeleton-loader(v-for="a in 5" :key="a.key" type="list-item-avatar-two-line")
</template>
<script>
export default {
  computed: {
    opportunities() {
      return this.$store.getters['opportunities/list'];
    },
    loading() {
      return this.$store.getters['loading'];
    },
  },
  mounted() {
    let params = new URLSearchParams();
    params.append('filter[stage]', '1,2,3');
    params.append('page[size]', 10);
    params.append('sort', 'expected_close_date');
    this.$store.dispatch('opportunities/list', params);
  },
};
</script>
